import { useState } from 'react';

import Checkbox from '@components/Checkbox';

import { Container } from './styled';

interface Props {
  onFilterChecked?: (val: boolean) => void;
}

const AvailableRoomsFilter = ({ onFilterChecked }: Props) => {
  const [selected, setSelected] = useState<boolean>(false);

  const handleChange = (val: boolean) => {
    setSelected(val);
    onFilterChecked?.(val);
  };
  return (
    <Container>
      <Checkbox
        checked={selected}
        onChange={handleChange}
        title='Sadece müsait odaları göster'
      />
    </Container>
  );
};

export default AvailableRoomsFilter;
